import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Website } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = `/website`;

export function useAllWebsiteQuery({
	impersonationContext,
	pageSize = 25,
}: {
	impersonationContext?: Api.IImpersonationContext;
	pageSize?: number;
} = {}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Website>>({
		getNextPageParam: page => page.pageToken,
		queryKey: [BASE_QUERY_KEY, pageSize, impersonationContext],
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `website`,
					impersonationContext,
					queryParams: {
						pageToken: pageParam,
						pageSize,
					},
				}),
				'GET'
			),
		initialPageParam: '',
	});
}

export const invalidateAllWebsiteQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
